import { useEffect, useRef, useState } from "react";
import { ArrowsOutSimple, ArrowsInSimple } from "@phosphor-icons/react";

const KEY = "strata.timesheet.kpiMatrixHeight.v1";
const MIN = 200;

// Height-adjustable scroll box: drag the bottom-right grip (mouse/touch), or "Fit content" to let the page scroll instead.
export function ResizableBox({ children, defaultHeight = 384, testId }) {
  const [h, setH] = useState(() => {
    const v = localStorage.getItem(KEY);
    return v === "fit" ? "fit" : Number(v) || defaultHeight;
  });
  const drag = useRef(null);
  useEffect(() => { localStorage.setItem(KEY, String(h)); }, [h]);
  const boxRef = useRef(null);

  const onDown = (e) => {
    e.preventDefault();
    const start = h === "fit" ? boxRef.current.offsetHeight : h;
    drag.current = { y: e.clientY, start };
    const move = (ev) => {
      if (!drag.current) return;
      const next = Math.max(MIN, Math.min(window.innerHeight * 4, drag.current.start + ev.clientY - drag.current.y));
      setH(Math.round(next));
    };
    const up = () => { drag.current = null; window.removeEventListener("pointermove", move); window.removeEventListener("pointerup", up); };
    window.addEventListener("pointermove", move);
    window.addEventListener("pointerup", up);
  };
  const onKey = (e) => {
    if (e.key === "ArrowDown" || e.key === "ArrowUp") {
      e.preventDefault();
      const cur = h === "fit" ? boxRef.current.offsetHeight : h;
      setH(Math.max(MIN, cur + (e.key === "ArrowDown" ? 60 : -60)));
    }
  };
  const fit = h === "fit";
  return (
    <div className="relative" data-testid={testId}>
      <div ref={boxRef} className={fit ? "relative overflow-x-auto" : "relative overflow-auto"} style={fit ? undefined : { height: h }}>
        {children}
      </div>
      <div className="flex items-center justify-end gap-2 pt-1">
        <button type="button" onClick={() => setH(fit ? defaultHeight : "fit")} className="text-[10px] font-semibold text-slate-500 hover:text-slate-800 inline-flex items-center gap-1"
          data-testid={`${testId}-fit-toggle`} aria-pressed={fit}>
          {fit ? <><ArrowsInSimple size={11} /> Collapse</> : <><ArrowsOutSimple size={11} /> Fit content</>}
        </button>
        {!fit && <span className="text-[10px] text-slate-400">scroll inside or drag to resize</span>}
        <button type="button" onPointerDown={onDown} onKeyDown={onKey} aria-label="Resize panel height (drag, or use arrow keys)" title="Drag to resize"
          className="w-4 h-4 cursor-ns-resize touch-none text-slate-400 hover:text-slate-700 focus:outline-none focus:ring-2 focus:ring-[#327de3] rounded-sm" data-testid={`${testId}-handle`}>
          <svg viewBox="0 0 16 16" className="w-4 h-4" aria-hidden="true"><path d="M15 6L6 15M15 10l-5 5M15 14l-1 1" stroke="currentColor" strokeWidth="1.5" fill="none" /></svg>
        </button>
      </div>
    </div>
  );
}
